/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectBarcodeLookupPlan from 'modules/me/select-barcode-lookup-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import { hasScheduledChanges } from 'state/current-barcode-lookup/selectors';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ScheduledChangesNotice from 'modules/me/barcode-lookup/scheduled-changes-notice';

const EditPlan = (props) => {
    return (
        <Box>
            <DocumentHead title='Manage Barcode Lookup Plan Billing - Tower Systems' />
            <Topbar title='Barcode Lookup Plan' subTitle='Manage your Barcode Lookup subscription' selected='dispatch'>
                <Button primary link='/dashboard/barcode-lookup'>
                    View Subscription Details
                </Button>
            </Topbar>
            {props.hasScheduledChanges && (
                <Box marginBottom='xxlarge'>
                    <ScheduledChangesNotice></ScheduledChangesNotice>
                </Box>
            )}
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Barcode Lookup plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a Barcode Lookup plan below to view
                            the estimated plan price.
                        </Text>
                    </Box>
                    <Box>
                        <SelectBarcodeLookupPlan />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(EditPlan);
